import React from 'react';
import DatePicker from 'react-datepicker';
import {createUseStyles} from 'react-jss';
import ru from 'date-fns/locale/ru';

import {TEXT} from '../../../common-styles/typography-style';
import {COLORS} from '../../../utils/style-variables';
import {CalendarIcon} from '../../icons/calendar-icon';

import 'react-datepicker/dist/react-datepicker.css';

const useStyles = createUseStyles({
  '@global': {
    'div.react-datepicker': {
      borderColor: COLORS.lightGrey60Color
    },
    'div.react-datepicker-popper': {
      zIndex: 3
    },
    'div.react-datepicker__day': {
      userSelect: 'none',
      '&:hover': {
        backgroundColor: COLORS.lightGrey30Color
      }
    },
    'div.react-datepicker__day--selected': {
      backgroundColor: COLORS.blue100Color,
      '&:hover': {
        backgroundColor: '#1d5d90;'
      }
    },
    'div.react-datepicker__current-month': {
      padding: '5px 0',
      fontSize: '13px',
      fontWeight: 500,
      textTransform: 'capitalize',
      color: '#757575'
    },
    'div.react-datepicker__header': {
      backgroundColor: '#F6F7F8',
      borderColor: COLORS.lightGrey60Color
    },
    'button.react-datepicker__navigation': {
      top: 12
    }
  },
  datePicker: {
    display: 'none',
    '@media (min-width: 756px)': {
      display: 'block'
    }
  },
  date: {
    display: 'inline-block',
    position: 'relative',
    padding: '7px 14px 7px 34px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: COLORS.lightGrey60Color,
    borderRadius: 2,
    ...TEXT.defaultSize,
    color: COLORS.blackColor,
    outline: 'none',
    transition: 'all .100s ease-in-out',
    '& >svg': {
      position: 'absolute',
      left: 12,
      top: 10,
      '& path': {
        transition: 'all .100s ease-in-out'
      }
    },
    '&:focus, &:hover': {
      borderColor: COLORS.blue100Color,
      '& >svg path': {
        fill: COLORS.blue100Color
      }
    }
  }
});

const DateInput = React.forwardRef(({value, onClick}) => {
  const classes = useStyles();

  return (
    <button className={classes.date} onClick={onClick}>
      {value}
      <CalendarIcon />
    </button>
  );
}
);

export default ({selected, dateHandler}) => {
  const classes = useStyles();

  return (
    <div className={classes.datePicker}>
      <DatePicker
        dateFormat='dd.MM.yyyy'
        selected={selected}
        onChange={dateHandler}
        minDate={new Date('01.01.2020')}
        maxDate={new Date()}
        customInput={<DateInput />}
        popperPlacement='bottom-end'
        disabledKeyboardNavigation
        locale={ru}
        ref={null}
      />
    </div>
  );
};
